module.exports = __webpack_public_path__ + "img/X.49833589.png";